var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalSiteArticle',{attrs:{"page":_vm.termsPage,"nav-page":"terms"}})
}
var staticRenderFns = []

export { render, staticRenderFns }